var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"animated-title",class:{'animated-title--animated': _vm.animated}},[_c('span',[_vm._v("P")]),_c('span',[_vm._v("a")]),_c('span',[_vm._v("i")]),_c('span',[_vm._v("r")]),_c('span',[_vm._v("s")])])}
var staticRenderFns = []

export { render, staticRenderFns }